import React from 'react'
import './opportunity-card-component.scss'
import { Tag } from '../Tag'
import { Line } from '../Line'
import { ProjectListProps, LastMinuteListProps } from '../../types'
import { displayTicketSize } from '../../utils/helpers'
import { H4 } from '../Heading'
import { Anchor } from '../Anchor'
import { captureEvent } from '../../utils/posthogUtils/usePostHog'
import { EVENTS } from '../../utils/constants'

function OpportunityCard({
  id,
  projectSlug,
  projectName,
  assetClass,
  projectSummary,
  ticketSize,
  projectCover,
  handleClick,
  closingDate,
  currencyCode,
  dataTestId,
}: ProjectListProps) {
  return (
    <div
      key={id}
      className='project-card-container'
      tabIndex={0}
      onClick={() => {
        captureEvent(EVENTS.opportunity_page_visited, {
          projectSlug,
          id,
          projectName,
          assetClass,
          ticketSize,
          projectCover,
          closingDate,
        })
        handleClick && handleClick(projectSlug, id, projectName)
      }}
      data-testid={dataTestId}
    >
      <div className='project-card-container-cover'>
        <img src={projectCover} width={'100%'} height={'100%'} alt='project-display-image' />
      </div>
      <div className='project-card-container-wrapper'>
        <div className='title-container'>
          <h3 className='title'>{projectName}</h3>
        </div>

        <div className='opportunity-card-tag-container'>
          <div className='opportunity-card-asset '>{assetClass && <Tag text={assetClass} />}</div>
        </div>

        <Line />

        <div className='lower-container'>
          <div className='description-container'>
            <p>{projectSummary}</p>
          </div>

          <Line />

          <div className='stats-container'>
            <div className='opportunity-card-stats-card'>
              <p className='card-main'>
                {ticketSize && currencyCode
                  ? displayTicketSize(ticketSize, currencyCode)
                  : ticketSize}
              </p>
              <p className='card-sub'>Minimum Amount</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { OpportunityCard }

function OpportunityCardHorizontal({
  id,
  projectSlug,
  projectName,
  projectSummary,
  projectCover,
  handleClick,
}: LastMinuteListProps) {
  return (
    <div
      className='project-h-container'
      onClick={() => {
        captureEvent(EVENTS.opportunity_page_visited, { projectSlug, id, projectName })
        handleClick && handleClick(projectSlug, id, projectName)
      }}
    >
      <div className='project-h-image'>
        <img src={projectCover} alt='' />
      </div>
      <div className='project-h-content'>
        <div className='project-h-text'>
          <H4 text={projectName} />
          <p>
            {projectSummary} &nbsp;{' '}
            <Anchor
              text='know more'
              href={`/opportunity/${projectSlug}/${id}`}
              variant='basic-anchor'
            />
          </p>
        </div>
      </div>
    </div>
  )
}

export { OpportunityCardHorizontal }
